import { Component } from '@angular/core';
import moment from 'moment';
import { CrmService } from 'src/app/service/crm.service';

interface MonthStats {
  monthIndex: number;
  monthName: string;
  totalLeads: number;
  assignedLeads?: number;
  convertedLeads: number;
  inProgressLeads: number;
  lostLeads: number;
  notStartedLeads?: number;
  unAssignedLeads?: number;
}
const MONTH_NAMES = [
  'January', 'February', 'March', 'April',
  'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December'
];


@Component({
    selector: 'app-calendar',
    imports: [],
    templateUrl: './calendar.component.html',
    styleUrls: ['../styles/leads.css', './calendar.component.css']
})
export class CalendarComponent {


  currentYear = new Date().getFullYear();
  months: MonthStats[] = [];

  constructor(private crmService: CrmService) {

  }

  ngOnInit() {
    const userDepartment = localStorage.getItem("department") || "";
    if (userDepartment === 'MARKETING') {
      window.location.href = '/#/home'; // Basic redirect
      return;
    }
    this.loadYearData(this.currentYear);
    this.getAdminOverView();
  }


  goToPreviousYear() {
    this.currentYear--;
    this.isYearNavigated = true;
    this.loadYearData(this.currentYear);
    this.isOverviewLoading = true;
    this.getAdminOverView();
  }

  goToNextYear() {
    this.currentYear++;
    this.isYearNavigated = true;
    this.loadYearData(this.currentYear);
    this.isOverviewLoading = true;
    this.getAdminOverView();
  }


  loadYearData(year: number) {
    const payload: any = { year };

    if (this.selectedProject === null) {
      payload.isAll = true;
    } else if (this.selectedProject && this.selectedProject.toUpperCase() === 'OUTBOUND') {
      payload.leadType = 'Outbound';
    } else {
      payload.project = this.selectedProject;
    }

    this.crmService.getCalendar(payload).subscribe({
      next: (res: any) => {
        const apiData = res.data || [];

        const MONTH_NAMES = [
          'January', 'February', 'March', 'April',
          'May', 'June', 'July', 'August',
          'September', 'October', 'November', 'December'
        ];

        this.months = MONTH_NAMES.map((monthName, index) => {
          const monthNumber = index + 1;
          const match = apiData.find((m: any) => m.month === monthNumber);

          return {
            year,
            monthIndex: index,
            month: monthNumber,
            monthName,
            totalLeads: match?.totalLeads ?? 0,
            assignedLeads: match?.totalAssignedLeads ?? match?.assignedLeads ?? 0,
            convertedLeads: match?.totalConvertedLeads ?? 0,
            inProgressLeads: match?.totalInProgressLeads ?? 0,
            lostLeads: match?.totalLostLeads ?? 0,
            notStartedLeads:
              match?.totalNotStartedLeads ??
              match?.notStartedLeads ??
              0,
            unAssignedLeads:
              match?.totalUnAssignedLeads ??
              match?.unAssignedLeads ??
              0
          };
        });
      },
      error: err => {
        console.error('Calendar API failed', err);
        this.months = [];
      }
    });
  }

  // user info
  salesUserName = '';
  role = '';
  userProgress: 'Good' | 'Bad' | '' = '';

  // overview counts
  totalLeads = 0;
  inProgressLeads = 0;
  convertedLeads = 0;
  lostLeads = 0;

  // percentages
  inProgressPercent = '0%';
  convertedPercent = '0%';
  lostPercent = '0%';

  // trends
  totalLeadsChange = 0;
  inProgressChange = 0;
  convertedChange = 0;
  lostChange = 0;
  Math = Math;
  isOverviewLoading: boolean = true;
  private isYearNavigated: boolean = false;
  getAdminOverView() {
    // Determine project parameter
    const project =
      this.selectedProject && this.selectedProject !== 'ALL'
        ? this.selectedProject
        : undefined;

    // current year start & end dates
    const startDate = moment({ year: this.currentYear, month: 0, day: 1 })
      .startOf('day')
      .format('YYYY-MM-DDTHH:mm:ss.SSS');

    const endDate = moment({ year: this.currentYear, month: 11, day: 31 })
      .endOf('day')
      .format('YYYY-MM-DDTHH:mm:ss.SSS');

    this.isOverviewLoading = true;

    this.crmService.getLeadsOverview(project, startDate, endDate).subscribe({
      next: (res: any) => {
        const data = res?.data;
        if (!data) return;

        this.isOverviewLoading = false;

        // User info
        this.salesUserName = data.userName;
        this.role = data.role;
        this.userProgress = data.userProgress;

        // Counts
        this.totalLeads = data.totalLeadsCount;
        this.inProgressLeads = data.inProgressLeadsCount;
        this.convertedLeads = data.convertedLeadsCount;
        this.lostLeads = data.lostLeadsCount;

        // Percentages
        this.inProgressPercent = data.inProgressLeadsPercentage;
        this.convertedPercent = data.convertedLeadsPercentage;
        this.lostPercent = data.lostLeadsPercentage;

        // Trends
        this.totalLeadsChange = data.totalLeadsChange;
        this.inProgressChange = data.inProgressLeadsChange;
        this.convertedChange = data.convertedLeadsChange;
        this.lostChange = data.lostLeadsChange;
      },
      error: err => {
        console.error('Overview API failed', err);
        this.isOverviewLoading = false;
      }
    });
  }





  getTrendText(change: number) {
    if (change > 0) {
      return {
        value: change,
        text: 'more than last week',
        type: 'positive'
      };
    }

    if (change < 0) {
      return {
        value: Math.abs(change),
        text: 'less than last week',
        type: 'negative'
      };
    }

    return {
      value: 0,
      text: 'No change',
      type: 'neutral'
    };
  }



  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }


  selectedProject: string | null = null;
  selectedProjectLabel = 'ALL';

  selectProject(project: string) {
    if (project === 'ALL') {
      this.selectedProject = null;
      this.selectedProjectLabel = 'All';
    } else {
      this.selectedProject = project;
      this.selectedProjectLabel = project;
    }

    this.isDropdownOpen = false;
    this.loadYearData(this.currentYear);
    this.isOverviewLoading = true;
    this.getAdminOverView();


  }



}
